import { Sparkles, Zap } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export function AIConfigurationPage() {
  console.log('🎯 AIConfigurationPage component is rendering!');
  
  return (
    <div className="flex h-full w-full items-center justify-center p-6">
      <Card className="w-full max-w-2xl border-dashed">
        <CardContent className="flex flex-col items-center justify-center py-16 px-6 text-center">
          {/* Icon Container with Gradient Background */}
          <div className="relative mb-6">
            <div className="absolute inset-0 animate-pulse rounded-full bg-gradient-to-br from-accent-purple-500/20 to-accent-blue-violet-500/20 blur-xl" />
            <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-accent-purple-500/10 to-accent-blue-violet-500/10 ring-1 ring-accent-purple-500/20">
              <Sparkles className="h-12 w-12 text-accent-purple-500" strokeWidth={1.5} />
              <Zap className="absolute -right-2 -top-2 h-6 w-6 text-accent-blue-violet-500" strokeWidth={2} />
            </div>
          </div>

          {/* Heading */}
          <div className="mb-3 flex items-center justify-center gap-2">
            <h2 className="text-3xl font-semibold tracking-tight text-foreground">
              AI Configuration Coming Soon
            </h2>
          </div>

          {/* Description */}
          <p className="mb-6 max-w-md text-base text-muted-foreground leading-relaxed">
            We're building powerful AI-driven features to enhance your credit control workflow. 
            Advanced automation, intelligent insights, and smart recommendations will be available here soon.
          </p>

          {/* Feature Pills */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-sm">
            <div className="flex items-center gap-1.5 rounded-full bg-accent-purple-50 dark:bg-accent-purple-900/20 px-3 py-1.5 text-accent-purple-900 dark:text-accent-purple-500">
              <Sparkles className="h-3.5 w-3.5" />
              <span className="font-medium">Smart Automation</span>
            </div>
            <div className="flex items-center gap-1.5 rounded-full bg-accent-blue-violet-50 dark:bg-accent-blue-violet-900/20 px-3 py-1.5 text-accent-blue-violet-900 dark:text-accent-blue-violet-500">
              <Zap className="h-3.5 w-3.5" />
              <span className="font-medium">Predictive Analytics</span>
            </div>
            <div className="flex items-center gap-1.5 rounded-full bg-accent-lagoon-50 dark:bg-accent-lagoon-900/20 px-3 py-1.5 text-accent-lagoon-900 dark:text-accent-lagoon-500">
              <Sparkles className="h-3.5 w-3.5" />
              <span className="font-medium">Intelligent Insights</span>
            </div>
          </div>

          {/* Status Badge */}
          <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-muted px-4 py-2 text-sm text-muted-foreground">
            <div className="h-2 w-2 animate-pulse rounded-full bg-accent-info-500" />
            <span>Currently in development</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
